import { UserBonus } from 'config/types/bonus/userBonus'
import { useTranslation } from 'react-i18next'
import { revalidateHunnyLevel } from 'utils'
import { isCashbackBonusType } from 'utils/bonus'
import { ValidatedBonusStatusEnums, useValidateBonus } from '../../hooks'

const BonusInvalidMessage: React.FC<{
  bonus: UserBonus
}> = ({ bonus }) => {
  const validatedResult: ValidatedBonusStatusEnums = useValidateBonus(bonus)
  const { t } = useTranslation()

  return (
    <>
      {validatedResult === ValidatedBonusStatusEnums.HasOtherActivated &&
        t('Cannot activate more than one bonus of the same type')}
      {validatedResult === ValidatedBonusStatusEnums.UserType && t("Only for new users who haven't placed any bet yet")}

      {validatedResult === ValidatedBonusStatusEnums.UserLevel &&
        t(' Require a VIP level between {{minLevel}}-{{maxLevel}}', {
          minLevel: revalidateHunnyLevel(bonus.condition.minUserLevel),
          maxLevel: revalidateHunnyLevel(bonus.condition.maxUserLevel),
        })}

      {validatedResult === ValidatedBonusStatusEnums.Cancelled && t('Bonus has been cancelled')}

      {validatedResult === ValidatedBonusStatusEnums.Used && t('Bonus has been used')}
      {validatedResult === ValidatedBonusStatusEnums.Claimed && t('Bonus has been added to your balance')}
      {validatedResult === ValidatedBonusStatusEnums.Expired && t('Bonus has been expired')}
      {validatedResult === ValidatedBonusStatusEnums.Finish && (
        <>
          {isCashbackBonusType(bonus)
            ? t("You're on a winning streak!🎉 No cashback this time since you didn't lose.")
            : t('All the bonus amount has been used.')}
        </>
      )}
    </>
  )
}

export default BonusInvalidMessage
